import { useState } from 'react'

import type { TaskFeedPlatform } from '@/app/[locale]/tasks/components/TaskFeedCard/taskFeedCard.constants'

function samePlatforms(
  a: readonly TaskFeedPlatform[],
  b: readonly TaskFeedPlatform[]
): boolean {
  return a.length === b.length && a.every((platform, i) => platform === b[i])
}

/**
 * The Platforms menu across refetches: a new platform or order starts a new
 * query, and the menu keeps the last known list until its answer arrives
 * instead of vanishing under the skeleton.
 */
export function useStickyFeedPlatforms(
  current: readonly TaskFeedPlatform[] | undefined
): readonly TaskFeedPlatform[] {
  const [last, setLast] = useState<readonly TaskFeedPlatform[]>([])
  if (current && !samePlatforms(current, last)) {
    setLast(current)
  }
  return current ?? last
}
